module.exports = __webpack_public_path__ + "img/20191205171619914.9c9d564b.jpg";